import { fieldDocumentsDependencies } from '@pages/CompanyProfile/hooks/useRequiredDocuments/constants';
import { DocumentsFields } from '@services/requests/companyProfileService/types/mainData';
import { z } from 'zod';

import { CompanyProfileFormFields } from './types';

const fileSchema = z.object({
  id: z.string(),
  link: z.string(),
  title: z.string(),
});

export const companyProfileFormSchema = z.object({
  fullName: z.string().trim().min(3),
  shortName: z.string().trim().min(3),
  kpp: z.string().trim().min(3).max(9),
  legalAddress: z.string().trim().min(3),
  postalAddress: z.string().trim().min(3),
  settlementsCurrency: z.string().trim().min(1),
  representativeFullName: z.string().trim().min(1),
  jobTitle: z.string().trim().min(1),
  actionReason: z.string().trim().min(1),
  availabilityEdo: z.number(),
  operatorEdo: z.string(),

  registration: fileSchema.optional(),
  egrul: fileSchema.optional(),
  company_card: fileSchema.optional(),
  charter: fileSchema.optional(),
  decision: fileSchema.optional(),
});

export const companyProfileExtendedFormSchema = z.object({
  firstName: z.string().trim().min(3),
  lastName: z.string().trim().min(3),
  secondName: z.string(),
  fullName: z.string().trim().min(3),
  shortName: z.string().trim().min(3),
  kpp: z.string(),
  legalAddress: z.string().trim().min(3),
  postalAddress: z.string().trim().min(3),
  settlementsCurrency: z.string().min(1),
  representativeFullName: z.string(),
  jobTitle: z.string(),
  actionReason: z.string(),
  availabilityEdo: z.number(),
  operatorEdo: z.string(),

  registration: fileSchema.optional(),
  egrul: fileSchema.optional(),
  company_card: fileSchema.optional(),
  charter: fileSchema.optional(),
  decision: fileSchema.optional(),
});

export const getDynamicCompanyProfileFormSchema = (
  baseSchema: any,
  defaultFormState: CompanyProfileFormFields,
  currentFormState: CompanyProfileFormFields
) => {
  const dynamicCompanyProfileFormSchema = baseSchema.transform((data) => {
    let schema = baseSchema;

    const changedKeys = Object.entries(defaultFormState)
      .map(([key, value]) => {
        return data[key] !== value ? key : null;
      })
      .filter((key) => key !== null);

    const requredDocuments = Array.from(
      new Set(
        Object.entries(fieldDocumentsDependencies)
          .map(([_, checks]) =>
            checks
              .map((check) =>
                check.checkFn(changedKeys, currentFormState) ? check.requiredDocuments : []
              )
              .flat()
          )
          .flat()
      )
    );

    requredDocuments.forEach((requiredDocument: any) => {
      schema = schema.extend({
        [requiredDocument]: fileSchema,
      });
    });

    return schema.parse(data);
  });

  return dynamicCompanyProfileFormSchema;
};
